module.exports = __webpack_public_path__ + "img/0Q3A5798_L_Wood.caf3860a.jpg";